import React, { type FormEvent } from 'react';

import { SidebarVisibility } from 'src/constants/sidebarVisibility';
import { useAppSelector } from 'src/store/reducers';
import { hentOversettelse } from 'src/util/stringToLanguageLocales';

import type { HNSkjemaFrontend } from 'src/types/Resources';

import HelpTrigger from '@helsenorge/designsystem-react/components/HelpTriggerIcon';
import Title, { type TitleAppearances } from '@helsenorge/designsystem-react/components/Title';

import { getSidetittelId } from '@helsenorge/framework-utils/hn-page';
import type { FormDefinition } from '@helsenorge/refero';

const SkjemaTitle = ({
  formDefinition,
  resources,
  sidebarVisibility,
  openSidebar,
}: {
  sidebarVisibility?: number;
  resources?: HNSkjemaFrontend;
  formDefinition?: FormDefinition | null;
  openSidebar: (e: Event | FormEvent<unknown> | undefined) => void;
}): React.JSX.Element | null => {
  const { isMicroweb, showFormTitle } = useAppSelector(state => state.microweb);
  const hideFormTitle =
    !resources || !formDefinition || !formDefinition.Content || !formDefinition.Content.title || (isMicroweb && !showFormTitle);
  const appearance: TitleAppearances = isMicroweb ? 'title2' : 'title1';

  if (hideFormTitle) {
    return null;
  }
  return (
    <div className="page_refero__formtitlewrapper">
      <Title htmlMarkup="h1" appearance={appearance} className="page_refero__formtitle" id={!isMicroweb ? getSidetittelId() : undefined}>
        {formDefinition?.Content?.title}
      </Title>
      {sidebarVisibility === SidebarVisibility.On && !isMicroweb && (
        <span id="anchor_title_helptrigger" className="atom_helptrigger-container" data-testid="anchor_title_helptrigger">
          <HelpTrigger ariaLabel={hentOversettelse('hjelpeknapp_ariaLabel', resources)} onClick={openSidebar} size="xlarge" />
        </span>
      )}
    </div>
  );
};
export default SkjemaTitle;
